/**
 * Cart Upsell Scroll
 * ---------------------------------------------------------------------------
 * Smooche-style upsells: only the first 2 "Complete with" cards are visible in
 * the cart drawer; any additional cards are reached by scrolling down inside
 * the upsell list (not the whole cart).
 *
 * The list height is measured from the 2nd card so exactly two cards show
 * regardless of how long each product title is. Re-runs whenever the cart
 * drawer re-renders (add/remove) or after images load.
 */
(function () {
  var VISIBLE = 2;
  var DRAWER_ID = 'cart-drawer';

  function apply() {
    var lists = document.querySelectorAll(
      '#' + DRAWER_ID +
      ' .complementary-products__product-list:not(.complementary-products__product-list--carousel)'
    );

    Array.prototype.forEach.call(lists, function (list) {
      var cards = list.querySelectorAll(':scope > .horizontal-product-card');

      // 2 or fewer upsells: nothing to scroll, clear any previous cap.
      if (cards.length <= VISIBLE) {
        if (list.style.maxHeight) list.style.maxHeight = '';
        list.classList.remove('is-scrollable');
        return;
      }

      // Card heights depend on lazy images that load only once the drawer is
      // shown. Re-measure when each finishes so the cap stays accurate.
      var imgs = list.querySelectorAll('img');
      Array.prototype.forEach.call(imgs, function (img) {
        if (!img.complete && !img.getAttribute('data-upsell-bound')) {
          img.setAttribute('data-upsell-bound', '1');
          img.addEventListener('load', schedule, { once: true });
          img.addEventListener('error', schedule, { once: true });
        }
      });

      var anchor = cards[VISIBLE - 1]; // the 2nd card
      var height = anchor.offsetTop + anchor.offsetHeight - cards[0].offsetTop;

      if (height > 0) {
        var value = Math.round(height) + 'px';
        if (list.style.maxHeight !== value) list.style.maxHeight = value;
        list.classList.add('is-scrollable');
      }
    });
  }

  function schedule() {
    window.requestAnimationFrame(apply);
  }

  // Initial + common cart lifecycle hooks.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  document.addEventListener('cart:change', schedule);
  document.addEventListener('cart:refresh', schedule);
  window.addEventListener('load', schedule);

  if (window.MutationObserver) {
    // (a) Content observer: re-apply when the drawer content is replaced
    // (add to cart / remove / qty change). childList-only => our style/class
    // writes (attribute changes) do NOT re-trigger it, so no feedback loop.
    var contentObserver = new MutationObserver(function (mutations) {
      // Ignore the per-second reservation-timer countdown updates.
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target && target.closest && target.closest('.cart-reservation-timer')) {
          continue;
        }
        schedule();
        return;
      }
    });

    // (b) Open observer: the drawer is hidden on load (cards measure as 0), so
    // we must re-measure when it opens. The drawer toggles an `open` attribute
    // on itself — observing attributes (NOT subtree) avoids any feedback loop.
    var openObserver = new MutationObserver(schedule);

    var startObserving = function () {
      var drawer = document.getElementById(DRAWER_ID);
      if (!drawer) return;
      contentObserver.observe(drawer, { childList: true, subtree: true });
      openObserver.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserving);
    } else {
      startObserving();
    }
  }
})();
